module.exports = __webpack_public_path__ + "media/images/lb/161-b2337cd3a03f2ceb0dc530eb5a783432.svg";